// extracted by mini-css-extract-plugin
export default {"root":"unMSiM1Nka"};